module.exports = __webpack_public_path__ + "img/default-user-intern.1fb52e64.png";